import { useEffect, useRef, useState } from "react";
import { Result, Typography } from "antd";
import { LockOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { ROUTES } from "common/constants/routes";

const { Paragraph } = Typography;

const UnauthorizedPage = () => {
  const logoutTriggered = useRef(false);

  const { logout, loginWithRedirect } = useAuth0();
  const location = useLocation();

  const autoRedirect = location.state?.autoRedirect === true;
  const delay = location.state?.delay ?? 5;
  const reason = location.state?.reason;

  const [countdown, setCountdown] = useState(delay);

  useEffect(() => {
    if (!autoRedirect) return;
    if (logoutTriggered.current) return;

    const interval = setInterval(() => {
      setCountdown((c: any) => {
        if (c <= 1) {
          clearInterval(interval);

          logoutTriggered.current = true;

          const address = window.location.href.split(ROUTES.MAIN),
            logoutPath = `${address[0]}//${address[2]}/logout?reason=error`;

          // Auth0 v2: federated logout via openUrl callback
          logout({
            logoutParams: {
              returnTo: logoutPath,
            },
            openUrl: (url) => {
              window.location.href = url + '&federated';
            }
          });

          return 0;
        }
        return c - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [autoRedirect, logout]);

  return (
    <Result
      title="Not Authorised"
      icon={<LockOutlined style={{ fontSize: 48, color: "#e60054" }} />}
      subTitle="You do not have permission to access this application."
    >
      <div style={{ textAlign: "center" }}>
        <Paragraph>
          {reason === "TOKEN_AUTH_FAILED"
            ? "Your account is not enabled. Please contact your system administrator."
            : "Unauthorized access attempts are monitored and logged. If you believe this is an error, please contact your system administrator."}
        </Paragraph>

        {autoRedirect && (
          <Paragraph type="secondary">
            Redirecting to login in {countdown} seconds…
          </Paragraph>
        )}
      </div>
    </Result>
  );
};

export default UnauthorizedPage;
